import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import Contact from '../contact-api-client';

type ContactMessageResponse = {
  messages: Array<Message>;
  scheduledMessages: Array<ScheduledMessage>;
};
export const loadContactMessages = (contactId: number) =>
  createGenericDispatcher<ContactMessageResponse>({
    name: 'LOAD_CONTACT_MESSAGES',
    loadFunction: new Contact(contactId).getMessages,
    args: { contactId },
    shouldExecute: (state, args) => {
      const contactMessages = state.contacts.messagesByContactId[args.contactId];
      return !contactMessages || (contactMessages.dirty && !contactMessages.loading);
    },
  });
